import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Ambulance = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M12.667 5.333a2 2 0 011.996 1.883l.004.117h.718c.957 0 1.864.411 2.495 1.123l.108.129 1.574 1.967c.252.315.402.699.432 1.099l.006.15V16a.667.667 0 01-.589.662l-.078.005H18l-.082-.006a2.668 2.668 0 110-1.323h.004l.078-.005h.667L18.666 12 14 12a.667.667 0 01-.662-.589l-.005-.078V8.667c0-.122.033-.236.09-.334a.65.65 0 01-.085-.255L13.333 8v-.667a.666.666 0 00-.589-.662l-.077-.004H6a.666.666 0 00-.662.589l-.005.077v8h.751a2.668 2.668 0 110 1.334H4.667a.667.667 0 01-.663-.59L4 16V7.333a2 2 0 011.882-1.996L6 5.333h6.667zm-4 9.334a1.333 1.333 0 100 2.666 1.333 1.333 0 000-2.666zm6.666 0a1.333 1.333 0 100 2.666 1.333 1.333 0 000-2.666zm-6-7.334c.342 0 .624.258.663.59L10 8v1.333h1.333a.667.667 0 01.078 1.33l-.078.004H10V12a.667.667 0 01-1.329.078L8.667 12l-.001-1.334H7.333a.667.667 0 01-.077-1.328l.077-.005h1.333V8c0-.368.3-.667.667-.667zm6.052 1.334h-.718v2h3.278l-.999-1.25a1.997 1.997 0 00-1.431-.746l-.13-.004z"
          id="ambulance_line_a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="ambulance_line_b" fill="#fff">
          <use xlinkHref="#ambulance_line_a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#ambulance_line_a" />
        <g
          mask="url(#ambulance_line_b)"
          fill={props.color || theme.palette.grey600}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  ) : (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M19.61 10.943L17.057 8.39c-.25-.25-.59-.391-.944-.391h-1.447V6.667c-.001-.736-.598-1.334-1.334-1.334H5.335C4.597 5.333 4 5.931 4 6.668V16h1.367c.169 1.496 1.426 2.667 2.966 2.667 1.54 0 2.798-1.171 2.966-2.667H12.7c.169 1.496 1.426 2.667 2.966 2.667 1.54 0 2.798-1.171 2.966-2.667H20v-4.114c0-.354-.14-.693-.39-.943zm-11.277 6.39a1.669 1.669 0 01-1.666-1.666c0-.919.748-1.667 1.666-1.667.919 0 1.667.748 1.667 1.667 0 .918-.748 1.666-1.667 1.666zM12 10.667h-2v2H8v-2H6v-2h2v-2h2v2h2v2zm3.667 6.666A1.669 1.669 0 0114 15.667c0-.919.748-1.667 1.667-1.667.918 0 1.666.748 1.666 1.667 0 .918-.748 1.666-1.666 1.666zm-1-6v-2l1.448.001 1.999 2h-3.447z"
          id="ambulance_solid_a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="ambulance_solid_b" fill="#fff">
          <use xlinkHref="#ambulance_solid_a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#ambulance_solid_a" />
        <g mask="url(#ambulance_solid_b)" fill="#666">
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
